// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-folder_container__1FMCy","title":"empty-folder_title__3f4BI"};